<template>
<div class="chapter">
<div class="inner_page">
<p class="C600"><em><span id="page_x">Figures </span></em></p>
<p class="C612"><a href="#/html/10_1_Socrat#page_26"><span class="rr">1</span>Jacques-Louis David, <em>The Death of Socrates</em>, 1787 </a></p>
<p class="C609"><a href="#/html/10_1_Socrat#page_42"><span class="rr">2</span>Frontispiece image of Mendelssohn and Socrates, from J. Heinemann, <em>Moses Mendelssohn. Sammlung theils noch ungedruckter, theils andern Schriften zerstreuter Aufsätze und Briefe von ihm, an und über ihn</em>, Leipzig 1831 </a></p>
<p class="C609"><a href="#/html/10_1_Socrat#id_239"><span class="rr">3</span>Frontispiece, Moses Mendelssohn, <em>Phaedon oder über die Unsterblichkeit der Seele in drei Gesprächen</em>, Berlin 1767 </a></p>
<p class="C609"><a href="#/html/10_1_Socrat#id_241"><span class="rr">4</span>Rembrandt, <em>Saint Jerome in a Dark Chamber</em>, 1642 </a></p>
<p class="C609"><a href="#/html/10_1_Socrat#id_253"><span class="rr">5</span>Silhouette of Moses Mendelssohn, from Johann Caspar Lavater, <em>Physiognomische Fragmente, zur Beförderung der Menschenkenntnis und Menschenliebe </em></a></p>
<p class="C609"><span href="#/html/28_5_Moses#page_213" title="Link target outside of Sample"><span class="rr">6</span>Michelangelo, <em>Moses</em>, 1513–15 </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_List_of.vue?b3461b10